import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { onConsentChanged } from "@/lib/metaPixel";

const KEY = "dms_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);
  const decide = (val) => {
    localStorage.setItem(KEY, val);
    setShow(false);
    // Notify the Meta Pixel layer so it can boot itself once consent === "all".
    try { window.dispatchEvent(new CustomEvent("dms:cookie-consent-changed", { detail: { value: val } })); } catch { /* ignore */ }
    onConsentChanged();
  };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3 sm:px-6 sm:pb-6">
      <div className="dms-card mx-auto max-w-3xl p-4 sm:p-5 flex flex-col sm:flex-row gap-3 sm:items-center justify-between shadow-[0_20px_50px_rgba(10,35,66,0.18)]">
        <div className="text-[13.5px] text-[#1F2937] leading-relaxed">
          We use essential cookies to keep you signed in and analytics cookies to improve the platform.{" "}
          <Link to="/legal/privacy" className="font-semibold text-[#1D4E89] hover:text-[#0A2342] underline">Privacy policy</Link>.
        </div>
        <div className="flex gap-2 shrink-0">
          <button data-testid="cookie-decline" onClick={() => decide("essential")} className="dms-btn-ghost text-[13px] py-2 px-3">Essential only</button>
          <button data-testid="cookie-accept" onClick={() => decide("all")} className="dms-btn-accent text-[13px] py-2 px-3">Accept all</button>
        </div>
      </div>
    </div>
  );
}
